import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DevComponentTaggerService {

  constructor(private ngZone: NgZone) {}

  init() {
    if (environment.production) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.tagAll(), 500);

      const observer = new MutationObserver(() => {
        this.tagAll();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  private tagAll() {
    const ngApi = (window as any).ng;
    if (!ngApi || !ngApi.getComponent) {
      return;
    }

    document.querySelectorAll('*').forEach((el) => {
      if (el.hasAttribute('data-component')) {
        return;
      }
      try {
        const comp = ngApi.getComponent(el);
        if (comp) {
          const className = comp.constructor.name;
          // Konwersja nazwy klasy na ścieżkę pliku, np. NewHeaderComponent -> new-header
          const fileName = className
            .replace(/Component$/, '')
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .toLowerCase();
          el.setAttribute('data-component', className);
          el.setAttribute('data-file', `${fileName}/${fileName}.component.ts`);
        }
      } catch (e) {
        // Element nie jest komponentem Angular - ignoruj
      }
    });
  }
}
